export enum Feature {
    AutoRenew = 'autoRenew',
    Stories = 'stories',
    BuyMembershipPremiumDialog = 'buyMembershipPremiumDialog',
    ReferralProgram = 'referralProgram',
    HolidayFeature = 'holidayFeature',
    Recaptcha = 'recaptcha',
    Pm = 'pm',
    NudityDetection = 'nudity_detection',
    GeoBlock = 'geo_block',
}
